module.exports = __webpack_public_path__ + "static/img/6.0000efe.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/caseDetail/tianjiancase/6.png
// module id = D0jL
// module chunks = 19